import { apiClient } from './api';

export interface KbArticle {
  id: number;
  slug: string;
  title: string;
  body: string;
  category: string;
  tags: string[];
  read_time_minutes: number;
  view_count: number;
  is_published: boolean;
  author_user_id: number | null;
  author_name: string | null;
  created_at: string;
  updated_at: string;
}

export interface KbCategoryCount {
  category: string;
  count: number;
}

export interface KbInput {
  slug: string;
  title: string;
  body: string;
  category: string;
  tags?: string[];
  read_time_minutes?: number;
  is_published?: boolean;
}

function unwrap<T>(raw: any): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (Array.isArray(raw?.data)) return raw.data as T[];
  return [];
}

export async function listArticles(filters: { category?: string; search?: string } = {}): Promise<KbArticle[]> {
  const raw = await apiClient.get<any>('/knowledge-base', filters as Record<string, any>);
  return unwrap<KbArticle>(raw);
}

export async function listCategoryCounts(): Promise<KbCategoryCount[]> {
  const raw = await apiClient.get<any>('/knowledge-base/categories');
  return unwrap<KbCategoryCount>(raw);
}

export async function getArticle(id: number | string): Promise<KbArticle> {
  return apiClient.get<KbArticle>(`/knowledge-base/${id}`);
}

export async function createArticle(input: KbInput): Promise<KbArticle> {
  return apiClient.post<KbArticle>('/knowledge-base', input);
}

export async function updateArticle(id: number | string, input: Partial<KbInput>): Promise<KbArticle> {
  return apiClient.patch<KbArticle>(`/knowledge-base/${id}`, input);
}

export async function deleteArticle(id: number | string): Promise<void> {
  await apiClient.delete<void>(`/knowledge-base/${id}`);
}
